export const GET_ADS_SUMMARY = 'GET_ADS_SUMMARY';
export const GET_ADS_CHART = 'GET_ADS_CHART';
export const GET_ADS_ADVERTISERS = 'GET_ADS_ADVERTISERS';
export const GET_ADS_CREATIVES = 'GET_ADS_CREATIVES';
export const GET_ADS_CREATIVE_PROMPTS = 'GET_ADS_CREATIVE_PROMPTS';
export const GET_ADS_PROMPT_STATS = 'GET_ADS_PROMPT_STATS';
export const GET_ADS_PROMPT_DETAILS = 'GET_ADS_PROMPT_DETAILS';
